import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "caass-calendar-entry",
	templateUrl: "./calendar-entry.component.html",
	styleUrls: ["./calendar-entry.component.css"],
})
export class CalendarEntryComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	///////////////////
	// Data
	///////////////////

	@Input() DayNumber: any;
	@Input() IsOpen: any = false;

	@Output() DayChange: EventEmitter<any> = new EventEmitter();

	///////////////////

	///////////////////
	// Events
	///////////////////

	onOpenChange(val) {
		this.IsOpen = val;

		this.DayChange.emit({
			DayNumber: this.DayNumber,
			IsOpen: this.IsOpen,
		});
	}

	///////////////////
}
